<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <rundna-user-profile [userId]="clientUserId" [isCoachView]="true"></rundna-user-profile>
</div>
